import usePriorityModal, {
  priorityModals,
  useSetPriorityModal,
} from "@/shared/atoms/usePriorityModal";
import useBranchId from "@/shared/hooks/useBranchId";
import { useCallback, useEffect } from "react";
import { useLocation } from "react-router-dom";
import KioskIdleModal from "./KioskIdleModal";
import PendingPaymentModal from "./PendingPaymentModal";
import OrderCancelledByExternalProviderModal from "./OrderCancelledByExternalProviderModal";
import ConfirmationModal from "./ConfirmationModal";
import CashDroPaymentModal from "./CashDroPaymentModal";
import CashDroCancelRefundModal from "./CashDroCancelRefundModal";

const MODALS_CANT_CLOSE_ON_CLICK_OUTSIDE: priorityModals[] = [
  "pendingPayment",
  "orderCancelledByExternalProvider",
];

const PriorityOverlay = ({
  onClick,
  modal,
}: {
  onClick?: () => void;
  modal: priorityModals;
}) => {
  const canClose = MODALS_CANT_CLOSE_ON_CLICK_OUTSIDE.includes(modal) === false;

  return (
    <div
      onClick={() => (canClose ? onClick?.() : undefined)}
      className="top-0 left-0 fixed z-10000000 w-full h-full bg-text-secondary opacity-50"
    />
  );
};

const PriorityModals = () => {
  const location = useLocation();
  const [{ priorityModal: modal }] = usePriorityModal();
  const branch = useBranchId();

  const setModal = useSetPriorityModal();
  const onExit = useCallback(() => {
    return setModal("", {});
  }, []);

  useEffect(() => {
    onExit();
  }, [branch]);

  useEffect(() => {
    setModal("");
  }, [location.pathname]);

  return (
    <>
      {modal && <PriorityOverlay onClick={onExit} modal={modal} />}
      {modal === "pendingPayment" && (
        <PendingPaymentModal closeOnClickOutside={false} zIndex={10000001} />
      )}
      {modal === "kioskIdle" && <KioskIdleModal onExit={onExit} />}
      {modal === "orderCancelledByExternalProvider" && (
        <OrderCancelledByExternalProviderModal onExit={onExit} />
      )}
      {modal === "cashDroPayment" && (
        <CashDroPaymentModal onExit={onExit} zIndex={10000001} />
      )}
      {modal === "cashDroCancelRefund" && (
        <CashDroCancelRefundModal onExit={onExit} zIndex={10000001} />
      )}
      {modal === "confirmation" && (
        <ConfirmationModal
          onExit={onExit}
          zIndex={10000001}
          className="md:w-180 lg:w-206"
        />
      )}
    </>
  );
};

export default PriorityModals;
